import { render, staticRenderFns } from "./vgmLogDialog.vue?vue&type=template&id=7b835cbe&scoped=true&"
import script from "./vgmLogDialog.vue?vue&type=script&lang=js&"
export * from "./vgmLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b835cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b835cbe')) {
      api.createRecord('7b835cbe', component.options)
    } else {
      api.reload('7b835cbe', component.options)
    }
    module.hot.accept("./vgmLogDialog.vue?vue&type=template&id=7b835cbe&scoped=true&", function () {
      api.rerender('7b835cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/vgm/vgmLogDialog.vue"
export default component.exports